import React from 'react'
import cx from 'classnames'
import styles from './ProgressBar.sass'

interface BarProps {
  progress: number
  style?: 'striped'
}

interface ProgressBarProps {
  bars: Array<BarProps>
}

const ProgressBar = (props: ProgressBarProps) => {
  return (
    <div className={styles.progress}>
      {props.bars.map((props, index) => {
        return (
          <div
            key={index}
            className={cx(
              styles.progressBar,
              props.style === 'striped' && styles.progressBarStriped
            )}
            style={{ width: `${props.progress}%` }}
          />
        )
      })}
    </div>
  )
}

export default ProgressBar
